import { authAPI, consentAPI } from '../services/redwolfSdkAPI';
import { appConfig } from './appConfig';
import * as Sentry from '@sentry/react';
import { getLocalStorage, getToken } from './localStorage';
import { isArray } from 'lodash';

export const checkEmailIdExits = (email: any, captchaToken: string) => {
	return authAPI
		.emailExists({ email: email, reCaptchaToken: captchaToken })
		.then((response: any) => {
			if (response.constructor.$metadata$.simpleName === 'Success' && response.data) {
				return response.data.exists;
			}
			if (response.response && response.response.status !== 400) {
				throw new Error(response);
			}
		})
		.catch((err: any) => {
			throw err;
		});
};

export const getUserConsentStatus = (consentIds: string[]) => {
	const getUserProfile = getLocalStorage('userProfile');
	const userConsentStatusPayload = {
		userId: getUserProfile && getUserProfile.userId,
		userIdType: appConfig.userIdType,
		consentIds: consentIds,
		consentGroupIds: [],
		accessToken: getToken()
	};

	return consentAPI
		.requestUserConsentStatus(userConsentStatusPayload)
		.then((response: any) => {
			const consentAPIStatus = response.constructor.$metadata$.simpleName;

			if (consentAPIStatus === 'Success') {
				if (response.data.userExists) {
					const consents = response.data.consents.toArray();

					let consentStatus = '';

					if (isArray(consents)) {
						consents.forEach((consent: any) => {
							if (consentStatus !== 'UNKNOWN' && consentStatus !== 'POLICY_CHANGE') {
								if (consent.lastInteractedConsentStatus === 'ACTIVE') {
									if (
										consent.lastInteractedConsentStatus === consent.currentConsentStatus &&
										consent.lastInteractedVersion === consent.currentConsentVersion
									) {
										consentStatus = consent.lastInteractedConsentStatus;
									} else {
										consentStatus = 'POLICY_CHANGE';
									}
								} else {
									consentStatus = consent.lastInteractedConsentStatus;
								}
							}
						});
					}

					return consentStatus;
				} else {
					return 'UNKNOWN';
				}
			} else {
				return 'Failed';
			}
		})
		.catch((err: any) => {
			Sentry.captureException(err);
			return 'Failed';
		});
};
